import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useLoad, act } from "@/lib/hooks";
import { api } from "@/lib/api";
import { Section, Field } from "@/components/common";

export function DocumentSettings({ can }) {
  const [d, reload] = useLoad("/tenant/document-settings");
  const [f, setF] = useState(null);
  useEffect(() => { if (d) setF(d); }, [d]);
  if (!f) return null;
  const save = async () => { if (await act(() => api.put("/tenant/document-settings", f), "Document settings saved")) reload(); };
  return (
    <Section title="Documents" testId="document-settings">
      <div className="grid gap-4 p-5 lg:grid-cols-2">
        <Field label="Quote terms and conditions"><Textarea rows={7} data-testid="doc-quote-terms" disabled={!can} value={f.quote_terms} onChange={(e) => setF({ ...f, quote_terms: e.target.value })} placeholder="e.g. 50% deposit on approval. Prices valid for the stated period. Artwork approval required before printing." /></Field>
        <Field label="Invoice payment instructions"><Textarea rows={7} data-testid="doc-payment-instructions" disabled={!can} value={f.payment_instructions} onChange={(e) => setF({ ...f, payment_instructions: e.target.value })} placeholder="e.g. Please quote the invoice number as your payment reference." /></Field>
      </div>
      <p className="px-5 pb-3 text-xs text-slate-500">Bank and mobile money details from Client portal settings are added to invoices automatically.</p>
      {can && <div className="border-t border-slate-200 px-5 py-3"><Button data-testid="doc-settings-save" onClick={save} className="bg-[#13294B] hover:bg-[#1c3a66]">Save document settings</Button></div>}
    </Section>
  );
}
